export enum StockStatus {
  OutOfStock = 1,
  LowStock = 2,
  Overstock = 3
}